<template>
  <div class="video-id">
    <collapsibleComponent body-classes="no-padding" :is-open="true">
      <template #header> <div class="title-header" v-html="title"></div> </template>
      <template #body>
				<div class="description">
					{{description}}
				</div>
        <youtube
          :player-vars="playerVars"
          :video-id="videoId"
          ref="youtube"
        ></youtube>
      </template>
    </collapsibleComponent>
  </div>
</template>
<script>
import collapsibleComponent from '@/components/collapsible.component'
export default {
  name: 'youTube',
	props: {
		title:{
			type:String,
		},
		description: {
			type: String,
		},
		videoId:{
			type:[String],
		},
		playerVars: {
			type: [Object],
			default(){
				return {
					'modestbranding': 1,
					'autoplay': 0,
					'controls': 2,
					'rel': 0,
					'fs': 0,
					'iv_load_policy': 3,
					'enablejsapi': 0
				}
			}
		},
	},
	components:{
		collapsibleComponent
	},
};
</script>
<style scoped lang="scss">
.description {
	padding: 12px;
	font-size: 15px;
}
</style>

<style lang="scss">
.video-id {
	iframe {
    width: 100%;
    display: inherit;
	}
	.title-header {
		font-size: 20px;
	}
}
</style>